import React from 'react'
import { Outlet } from 'react-router-dom'

const Settings: React.FC = () => {
  // Settings layout wrapper with padding
  // Navigation is handled by the main Layout sidebar
  return (
    <div className="p-8">
      <Outlet />
    </div>
  )
}

export default Settings
